import {
  AuditLogEntryType,
  IAuditLogResponse,
  IAuditLogResponseItem,
} from 'shared';

import { orgHeader } from '../../../../common/lib/axiosBaseQuery';
import { CacheTags } from '../../types/cacheTags';
import { emptySplitApi } from '../baseApi';

interface FetchAuditLogsArgs {
  organisationId: string;
  entityType?: AuditLogEntryType;
  entityId?: string;
}

export const auditLogApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchAuditLogs: builder.query<IAuditLogResponseItem[], FetchAuditLogsArgs>({
      query: ({ organisationId, entityType, entityId }) => ({
        url: `/audit-logs`,
        method: `GET`,
        headers: {
          [orgHeader]: organisationId,
        },
        params: {
          ...(entityType ? { entityType } : {}),
          ...(entityId ? { entityId } : {}),
        },
      }),
      transformResponse: (rawResult: IAuditLogResponse) => {
        return rawResult?.auditLogs;
      },
      providesTags: result => result ?
        [
          ...result.map(({ id }) => ({ type: CacheTags.AuditLogs, id })),
          { type: CacheTags.AuditLogs, id: `LIST` },
        ]
        : [{ type: CacheTags.AuditLogs, id: `LIST` }],
    }),

  }),
});

export const {
  useFetchAuditLogsQuery,
} = auditLogApi;
